// https://git.hubteam.com/HubSpot/PropertiesFrontendTeam/issues/1899
export const fullWidthCellClassName = 'full-width-cell';